module.exports = __webpack_public_path__ + "img/p3.2617a318.png";